import { IGenericTreeNode } from '../ix-generic-tree-types.js';

const ixGenericTreeTestData: IGenericTreeNode = {
  id: 'root',
  label: '',
  children: [
    {
      id: 'level-1-1',
      label: 'Global',
      secondaryLabel: null,
      parentId: '',
      childrenCount: 2,
      disabled: false,
      indeterminate: true,
      checked: false,
      icon: 'globe',
      children: [
        {
          id: 'level-2-1',
          label: 'EMEA',
          secondaryLabel: null,
          parentId: 'level-1-1',
          childrenCount: 2,
          disabled: false,
          indeterminate: true,
          checked: false,
          icon: 'map',
          children: [
            {
              id: 'level-3-1',
              label: 'France',
              secondaryLabel: null,
              parentId: 'level-2-1',
              childrenCount: 2,
              disabled: false,
              indeterminate: true,
              checked: false,
              icon: 'flag',
              children: [
                {
                  id: 'level-4-1',
                  label: 'MRS3',
                  secondaryLabel: 'Porte 4, 6 Bassin Léon Gourret',
                  parentId: 'level-3-1',
                  childrenCount: 0,
                  disabled: false,
                  indeterminate: false,
                  checked: false,
                  icon: 'location_on',
                  children: [],
                },
                {
                  id: 'level-4-2',
                  label: 'PAR1',
                  secondaryLabel: '45 Avenue Victor Hugo',
                  parentId: 'level-3-1',
                  childrenCount: 0,
                  disabled: false,
                  indeterminate: false,
                  checked: true,
                  icon: 'location_on',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default ixGenericTreeTestData;
